/* eslint-disable react-hooks/exhaustive-deps */
import type { RootState } from 'src/redux/store';

import { useParams } from 'react-router';
import { Helmet } from 'react-helmet-async';
import React, { useState, useEffect } from 'react';

import { paths } from 'src/routes/paths';

import { getAssigneName } from 'src/utils/commonUtils';

import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';
import { useAppSelector } from 'src/hook/hooks';

import { DetailsPageCommon } from 'src/components/details/details';

import { useGetChannelDtlMutation } from './slice/channelApi';
import ChannelFormHandler from './components/channelFormHandler';

function ChannelEdit() {
  //local states
  const [currnetChannel, setCurrentChannel] = useState<any>({});

  // api call
  const [getChannelDtl, { isLoading }] = useGetChannelDtlMutation();

  //selected channel id
  const { id = '' } = useParams();

  //meta data
  const metadata = { title: `Channel Details | Channel - ${CONFIG.appName}` };

  //translation function
  const { t } = useTranslate('navbar');

  const { loginApiData } = useAppSelector(
    (state: RootState & { auth: RootState['auth'] }) => state.auth
  );

  useEffect(() => {
    if (!id) return;

    getChannelDtl(id)
      .unwrap()
      .then(async (res) => {
        const channelDtl = res?.data?.channel ?? {};

        // Prepare assigned user/team names
        const assignUserListName =
          channelDtl.channelassign?.map((assign: any) =>
            getAssigneName(
              assign.assignedType === 'USER' ? assign.assignedUser : assign.assignedTeam,
              assign.assignedType
            )
          ) ?? [];

        // Merge assigned user/team objects with assignedType
        const channelassign = channelDtl.ChannelAssign?.map((assign: any) => ({
          ...(assign.assignedUser || {}),
          ...(assign.assignedTeam || {}),
          assignedType: assign.assignedType || 'USER',
        })) ?? [
          {
            ...loginApiData,
            assignedType: 'USER',
          },
        ];

        // Update state with merged data
        setCurrentChannel({
          ...channelDtl,
          assignUserListName,
          channelassign,
        });
      })
      .catch((err) => {
        console.error('Error fetching channel detail:', err);
      });
  }, [id]);

  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <DetailsPageCommon
        heading={currnetChannel?.channelName || 'Unknown'}
        backHref={paths.channel.root}
        breadcrumbsLink={[
          { name: `${t('CHANNEL')}`, href: paths.channel.root },
          { name: `${t('EDITING')} ${currnetChannel?.channelName || 'Unknown'}` },
        ]}
        components={<ChannelFormHandler selectedChannel={currnetChannel} isLoading={isLoading} />}
      />
    </>
  );
}

export default ChannelEdit;
